import { render, staticRenderFns } from "./ReviewsEditLegacy.vue?vue&type=template&id=5d992e0c"
import script from "./ReviewsEditLegacy.vue?vue&type=script&lang=js"
export * from "./ReviewsEditLegacy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports